"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ReferenceAnnotation {
    constructor(imageName, lat, long, height, turnOn /*, latAccuracy: number, longAccuracy: number, heightAccuracy: number*/) {
        this.entityRef = null;
        this.entityObj = null;
        this.pinRef = null;
        this.imageName = imageName;
        this.lat = lat;
        this.long = long;
        this.height = height;
        this.turnOn = turnOn;
        this.referenceAnnotationMarkedImages = null;
        /*this.latAccuracy = latAccuracy;
        this.longAccuracy = longAccuracy;
        this.heightAccuracy = heightAccuracy;*/
    }
}
exports.ReferenceAnnotation = ReferenceAnnotation;
